<form class="AcquisitionCosts__Form" [formGroup]="acquisitionForm">
  @for (field of fieldList; track field) {
    @if (newCategory(field.subCategory)) {
      <h3
        class="AcquisitionCosts__Heading"
        [innerHTML]="getSubtotalLabel(field.subCategory)"
      ></h3>
    }
    <span
      class="AcquisitionCosts__FormField"
      [ngClass]="{ AcquisitionCosts__subTotalRow: isSubtotalRow(field.name) }"
    >
      <ng-container dynamicField [field]="field" [group]="acquisitionForm">
      </ng-container>
    </span>
    @if (isSubtotalRow(field.name)) {
      <div class="flex-break"></div>
    }
  }
</form>
